import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4f0399a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-py-4 p-px-3" }
const _hoisted_2 = { class: "card p-grid p-shadow-0" }
const _hoisted_3 = { class: "p-col-12 p-md-4" }
const _hoisted_4 = { class: "p-float-label p-mt-4" }
const _hoisted_5 = { for: "name" }
const _hoisted_6 = { class: "p-float-label p-mt-5" }
const _hoisted_7 = { for: "description" }
const _hoisted_8 = { class: "p-field-checkbox" }
const _hoisted_9 = { for: "print-stock-pos" }
const _hoisted_10 = { class: "p-field-checkbox" }
const _hoisted_11 = { for: "print-stock-pos" }
const _hoisted_12 = { class: "p-col-12 p-md-5" }
const _hoisted_13 = { class: "p-d-flex p-flex-wrap p-justify-between" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "p-col-12 p-md-2" }
const _hoisted_16 = ["for"]
const _hoisted_17 = { class: "p-field-checkbox" }
const _hoisted_18 = { for: "terminal-code-bar" }
const _hoisted_19 = { class: "p-field-checkbox" }
const _hoisted_20 = { for: "print-code-bar-ticket" }
const _hoisted_21 = { class: "p-px-3" }
const _hoisted_22 = { class: "card p-grid p-shadow-0" }
const _hoisted_23 = { class: "p-d-flex p-justify-between p-pt-3" }
const _hoisted_24 = {
  key: 2,
  class: "p-d-flex p-ai-center p-justify-center",
  style: {"height":"calc(100vh - 200px)"}
}

import { computed, defineAsyncComponent, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useTerminals } from "@/graphql/terminal/terminals";
import { useUpdateTerminal } from "@/graphql/terminal/update-terminal";
import { useSequenceCheckActiveTerminal } from "@/graphql/sequence/sequence-check-active-terminal";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";
import { EAccessMenu } from "@/graphql/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TerminalTab',
  setup(__props) {

const TerminalForm = defineAsyncComponent(
  () => import("@/components/terminal/TerminalCreate.vue")
);
const TerminalUsers = defineAsyncComponent(
  () => import("@/components/terminal/TerminalUsers.vue")
);
const TerminalCategories = defineAsyncComponent(
  () => import("@/components/terminal/TerminalCategories.vue")
);
const TerminalPrinterMargins = defineAsyncComponent(
  () => import("@/components/terminal/TerminalPrinterMargins.vue")
);

const { tm } = useI18n();
const activeValue = ref(0);
const settings = tm("terminal.printerSettings") as string[];
const statusList = ["enabled", "disabled"];
const printerOptions = {
  1: settings.slice(0, 3).map((label, value) => ({ label, value })),
  2: settings.slice(3).map((label, value) => ({ label, value: value + 3 })),
};
const { terminalsLoading, terminals } = useTerminals();
const { updateLoading, updateTerminal, selectedKeys, setSelected, selected } =
  useUpdateTerminal();
const permissions = computed(() => {
  const acc = getAccess(EAccessMenu.Terminal);
  const noRestriction = canNavigateAnywhere();
  return {
    update: (acc?.update || noRestriction) && !updateLoading.value,
    create: acc?.create || noRestriction,
  };
});
const menu = computed(() =>
  terminals.value.map((ter) => ({
    label: ter.name,
    number: ter.number,
    command: () => setSelected(ter),
    style: selected.value?.id === ter.id ? "background: #FBC02D" : "",
  }))
);
const nexNumber = computed(
  () => (terminals.value[terminals.value.length - 1]?.number || 0) + 1
);
const { checkActive, loadingCheckActive } = useSequenceCheckActiveTerminal(
  () => {
    selected.value.active = activeValue.value;
  }
);

function setTerminalActive(active: number) {
  if (active == 0) {
    activeValue.value = active;
    checkActive(selected.value.id);
  } else selected.value.active = active;
}

return (_ctx: any,_cache: any) => {
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Menubar, { model: menu.value }, _createSlots({
      end: _withCtx(() => [
        _createTextVNode(" Gérez vos terminaux ")
      ]),
      _: 2
    }, [
      (permissions.value.create)
        ? {
            name: "start",
            fn: _withCtx(() => [
              _createVNode(_unref(TerminalForm), { number: nexNumber.value }, null, 8, ["number"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["model"]),
    (_unref(terminalsLoading))
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          style: {"height":"0.3rem"},
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    (_unref(selected))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.details")), 1),
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    disabled: true,
                    id: "name",
                    type: "text",
                    modelValue: _unref(selected).name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(selected).name) = $event)),
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("product.name")), 1)
                ]),
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_Textarea, {
                    autoResize: true,
                    rows: "3",
                    cols: "30",
                    id: "description",
                    style: {"width":"100%"},
                    modelValue: _unref(selected).description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(selected).description) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("terminal.description")), 1)
                ]),
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.printStock")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputSwitch, {
                    id: "print-stock-pos",
                    modelValue: _unref(selected).printStockPos,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(selected).printStockPos) = $event)),
                    "false-value": 0,
                    "true-value": 1
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(`terminal.${statusList[1 - _unref(selected).printStockPos]}`)), 1)
                ]),
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.allowDiscountLines")), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_InputSwitch, {
                    id: "print-stock-pos",
                    modelValue: _unref(selected).allowDiscountLines,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(selected).allowDiscountLines) = $event)),
                    "false-value": 0,
                    "true-value": 1
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t(`terminal.${statusList[1 - _unref(selected).allowDiscountLines]}`)), 1)
                ])
              ]),
              _createVNode(_component_Divider, {
                class: "p-divider-hidden",
                layout: "vertical"
              }),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.printerSetting")), 1),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (option) => {
                    return _createElementVNode("span", { key: option }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(printerOptions[option], (setting, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: index,
                          class: "p-field-checkbox"
                        }, [
                          _createVNode(_component_Checkbox, {
                            modelValue: _unref(selected).printerSettings,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(selected).printerSettings) = $event)),
                            id: `printer${setting.value}`,
                            name: "printer",
                            value: setting.value
                          }, null, 8, ["modelValue", "id", "value"]),
                          _createElementVNode("label", {
                            for: `printer${setting.value}`
                          }, _toDisplayString(setting.label), 9, _hoisted_14)
                        ]))
                      }), 128))
                    ])
                  }), 64))
                ]),
                _createVNode(_unref(TerminalPrinterMargins), {
                  margeActive: _unref(selected).margeActive,
                  "onUpdate:margeActive": _cache[5] || (_cache[5] = ($event: any) => ((_unref(selected).margeActive) = $event)),
                  modelValue: _unref(selected).printerMargins,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(selected).printerMargins) = $event))
                }, null, 8, ["margeActive", "modelValue"])
              ]),
              _createVNode(_component_Divider, {
                class: "p-divider-hidden",
                layout: "vertical"
              }),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.status")), 1),
                (_unref(loadingCheckActive))
                  ? (_openBlock(), _createBlock(_component_ProgressBar, {
                      key: 0,
                      class: "p-mb-3",
                      mode: "indeterminate",
                      style: {"height":"5px"}
                    }))
                  : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (status, index) => {
                  return _createElementVNode("div", {
                    key: index,
                    class: "p-field-checkbox"
                  }, [
                    _createVNode(_component_RadioButton, {
                      onClick: ($event: any) => (setTerminalActive(1 - index)),
                      "model-value": _unref(selected).active,
                      id: `active${index}`,
                      name: "active",
                      value: 1 - index
                    }, null, 8, ["onClick", "model-value", "id", "value"]),
                    _createElementVNode("label", {
                      for: `active${index}`
                    }, _toDisplayString(_ctx.$t(`terminal.${status}`)), 9, _hoisted_16)
                  ])
                }), 64)),
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.codeBar")), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_InputSwitch, {
                    id: "terminal-code-bar",
                    modelValue: _unref(selected).codeBar,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(selected).codeBar) = $event)),
                    "false-value": 0,
                    "true-value": 1
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t(`terminal.${statusList[1 - _unref(selected).codeBar]}`)), 1)
                ]),
                _createElementVNode("h5", null, _toDisplayString(_ctx.$t("terminal.printCodeBarTicket")), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_InputSwitch, {
                    id: "print-code-bar-ticket",
                    modelValue: _unref(selected).printBarcode,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(selected).printBarcode) = $event)),
                    "false-value": 0,
                    "true-value": 1
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t(`terminal.${statusList[1 - _unref(selected).printBarcode]}`)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(TerminalUsers), {
                modelValue: _unref(selected).users,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(selected).users) = $event)),
                class: "p-col-12 p-md-5"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Divider, {
                class: "p-divider-hidden",
                layout: "vertical"
              }),
              _createVNode(_unref(TerminalCategories), {
                modelValue: _unref(selectedKeys),
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(selectedKeys) ? (selectedKeys).value = $event : null)),
                class: "p-col-12 p-md-6"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_Button, {
              label: _ctx.$t('back'),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.back())),
              class: "p-button-warning",
              icon: "pi pi-arrow-up-left p-px-3"
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              disabled: !permissions.value.update,
              class: "p-button-success",
              icon: "pi pi-save",
              label: _ctx.$t('terminal.saveChanges'),
              loading: _unref(updateLoading),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(updateTerminal)()))
            }, null, 8, ["disabled", "label", "loading"])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_Button, {
            label: _ctx.$t('back'),
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.back())),
            class: "p-px-3 p-button-text p-button-danger p-text-bold",
            icon: "pi pi-arrow-up-left",
            style: {"font-size":"18px"}
          }, null, 8, ["label"])
        ]))
  ], 64))
}
}

})